import { axiosInstance } from "./axiosInstance";
import {publicAxiosInstance} from "./publicAxiosInstance";

interface SendOTPResponse {
  requestId: string;
}

interface VerifyOTPResponse {
  message: string;
  token: string;
  refreshToken: string;
  sessionId: string;
}

export async function getOTP(mobile: string) {
  try {
    const res = await publicAxiosInstance.post<SendOTPResponse>(
      "/doctor-profile/auth/otp/send",
      { 
        mobileNumber: mobile 
      },
      {
        headers: {
          "Content-Type": "application/json",
          accept: "*/*",
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("Send OTP API error:", error);
    throw error;
  }
}

export async function verifyOTP({
  otp,
  requestId,
}: {
  requestId: string;
  otp: string;
}) {
  try {
    const res = await publicAxiosInstance.post<VerifyOTPResponse>(
      "/doctor-profile/auth/otp/verify",
      {
        requestId,
        otp,
      },
      {
        headers: {
          "Content-Type": "application/json",
          accept: "*/*",
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("Verify OTP API error:", error);
    throw error;
  }
}

interface JWTFetchResponse {
  token: string;
  refreshToken: string;
  message: string;
  status: boolean;
}

interface RefreshTokenResponse {
  accessToken: string;
}

export async function fetchJWT(mobile: string) {
  try {
   // console.log("Making JWT API request for mobile:", mobile) // Debug log
    const res = await publicAxiosInstance.post<JWTFetchResponse>(
     "/doctor-profile/auth/login",
      { mobile: "91" + mobile },
    )
    //console.log("JWT API response:", res.data) // Debug log
    return res.data
  } catch (error) {
    console.error("JWT API error:", error) // Debug log
    throw error
  }
}

export async function refreshToken(refreshToken: string) {
  try {
   // console.log("Making JWT API request for mobile:", mobile) // Debug log
    const res = await publicAxiosInstance.post<RefreshTokenResponse>(
     "/doctor-profile/auth/refresh-token",
     null,
     {
      params: {
        refreshToken,
      },
    }
    )
    return res.data
  } catch (error) {
    console.error("Refresh Token API error:", error);
    throw error
  }
}